<template>

    <Toast/>

    <MenuHealthCompact/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">

            <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                <li class="pr-3"><a class="cursor-pointer">Help</a></li>
                <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">New Features</a></li>
            </ul>

            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h2>Hello!</h2>

                    <h3>2026 Medical Aid Rates Update and Consolidated Invoices Feature</h3>

                    <div class="flex flex-column gap-2">
                        <div class="field">
                            <span>
                                We have the majority of the medical aid rates uploaded for the various practitioners.
                                If you are  having issues with any particular rates, please send us an email to info@kitrin.com.
                                We will still continue with this process until we have the updates for each of the schemes across all
                                practitioner type. The current updates that have been included are - Discovery, Makoti, Anglovaal, Engen,
                                BMW, LA Health, Lonmin, Malcor, Medipos, Naspers, Quantum, Remedi, Retail, TFG, Tsogo Sun, University KZN,
                                Libcare, AMS, Netcare, Bankmed, Sasolmed, Gems, Bestmed, Medihelp, Medshield, Polmed, Samwumed, Parmed,
                                FedHealth, Bonitas, AECI, Barloworld, Horizon, MBMED, PG Group, SABC, Momentum, BPSA, FishMed, Golden Arrow,
                                Imperial Motus, Impala, Medimed, Moto Healthcare, PnP, Transmed, Sisonke Health, ThebeMed,
                                Wooltru, RUMED, Umvuzo, Old Mutual, Massmart, Tiger Brands, Compcare, Universal, Platinum Health,
                                Keyhealth and Profmed.
                                <br/><br/>
                                We have also released our Consolidated Invoice functionality. Instead of using the Billing Run functionality,
                                you can now do this more easily from the Calendar or the Appointments. This functionality is typically used
                                when you're generating an invoice with multiple appointments (eg. a private client that pays at the end of the
                                month). Note that you won't be able to create claims on a Consolidated Invoice. We recommend that you use
                                Individual invoices if you need to create claims for any of those invoices.
                            </span>
                        </div>

                        <div style="height: 15px;"></div>

                        <div class="field flex align-items-center gap-2 mb-4">
                            <Button label="Close" icon="pi pi-user" class="w-full" :loading="submitted"
                                    @click="processOverview"></Button>
                        </div>


                        <!--                        <div class="flex justify-content-center mt-4">-->
<!--                            <div-->
<!--                                class="w-full"-->
<!--                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">-->
<!--                                <iframe-->
<!--                                    src="https://iframe.mediadelivery.net/embed/568195/d9af70ec-e518-4f98-976d-09c63538e4ff?responsive=true"-->
<!--                                    loading="lazy"-->
<!--                                    style="position: absolute; inset: 0; width: 100%; height: 100%; border: 0;"-->
<!--                                    allowfullscreen>-->
<!--                                </iframe>-->
<!--                            </div>-->
<!--                        </div>-->

                    </div>

                </div>

            </div>

        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import userService from "@/service/UserService";

export default {
    components: {
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;

            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;

        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] No user data found.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
        }
    },
    data() {

        return {
            profile: {},
            submitted: false,
            skipWelcome: true,
            userConfiguration: {}
        }
    },
    methods: {
        processBookAppointment() {
            window.open("https://kitrin.com/book-appointment", '_blank');
        },
        async processOverview() {
            this.userConfiguration.showFeature = 'N';
            await userService.updateUserConfig(this.userStore.user.id, this.userConfiguration);

            setTimeout(() => {
                this.$router.push("healthOverviewHome");
            }, 0);
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
